import hero6 from "_texts/blog/heroes/hero6.js";

const textProps = {
  ...hero6,
  type: "dark",
};
export default textProps;
